function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Processing({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 1c1.654 0 3 1.346 3 3v4.168a6.432 6.432 0 014.703 6.187 6.432 6.432 0 01-4.755 6.2A3.004 3.004 0 0115 23H4c-1.654 0-3-1.346-3-3V4c0-1.654 1.346-3 3-3h11zm0 2H4c-.551 0-1 .448-1 1v16c0 .552.449 1 1 1h11c.256 0 .49-.096.667-.255a6.429 6.429 0 01-5.804-6.39A6.428 6.428 0 0116 7.94V4c0-.553-.449-1-1-1zm1.283 6.935a4.424 4.424 0 00-4.42 4.42 4.425 4.425 0 004.42 4.42 4.425 4.425 0 004.42-4.42 4.425 4.425 0 00-4.42-4.42zm-.065.491a1 1 0 011 1v2.591l1.573 1.278a1 1 0 11-1.26 1.552l-1.944-1.578a.999.999 0 01-.369-.776v-3.067a1 1 0 011-1zM8.566 8.35a1 1 0 110 2h-3.08a1 1 0 110-2h3.08zm5.083-3.72a1 1 0 110 2H5.486a1 1 0 110-2h8.163z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoProcessing = React.memo(Processing);
export default MemoProcessing;